import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faPowerOff, faUser, faTrash, faPencilAlt, faWindowClose, faExclamationTriangle, faPlus, faSearch, faTimes, faCodeCompare, faChevronDown, faWrench} from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(faLink);
  library.add(faUser);
  library.add(faPowerOff);
  library.add(faTrash);
  library.add(faPencilAlt);
  library.add(faWindowClose);
  library.add(faExclamationTriangle);
  library.add(faPlus);
  library.add(faSearch);
  library.add(faTimes);
  library.add(faCodeCompare);
  library.add(faChevronDown);
  library.add(faWrench);
}

export default initFontAwesome;
